module.exports = __webpack_public_path__ + "static/media/YF77_1.03c3785e.jpg";